import React from 'react';
import { motion } from 'framer-motion';

const FeatureItem = ({ imgSrc, title, text }) => (
  <motion.div 
    style={{ 
      flex: '1 1 250px', // Trošku jsem zvětšil základní šířku
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '20px'
    }}
    variants={{
      hidden: { opacity: 0, y: 30 },
      visible: { opacity: 1, y: 0 }
    }}
    transition={{ duration: 0.6, ease: "easeOut" }}
    whileHover={{ y: -10 }}
  >
    <div style={{ height: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
      <motion.img 
        src={imgSrc} 
        alt={title} 
        style={{ width: '110px', height: 'auto' }} 
        whileHover={{ rotate: 5, scale: 1.1 }}
      />
    </div>
    <h3 style={{ fontSize: '1.3rem', fontWeight: '700', minHeight: '3.2rem', display: 'flex', alignItems: 'center' }}>
      {title}
    </h3>
    <p style={{ marginTop: '10px', fontSize: '1rem', lineHeight: '1.5' }}>
      {text}
    </p>
  </motion.div>
);

const Features = () => {
  const data = [
    { id: 'a', title: 'Řemeslné zpracování', text: 'Každý kus je vyráběn s precizností a důrazem na kvalitu.' },
    { id: 'b', title: 'Přizpůsobení', text: 'Každý projekt upravuji na míru vašim potřebám a stylu.' },
    { id: 'c', title: 'Spolehlivost', text: 'Dodržení termínů, rozpočtu i výsledků je pro mě standard.' },
    { id: 'd', title: 'Udržitelnost', text: 'Používám ekologické materiály a postupy s minimálním dopadem.' }
  ];

  return (
    <section id="jak-pracuji" style={{ padding: '100px 20px', backgroundColor: '#FEF0D7', color: '#2b1f18', marginTop: '-70px', overflow: 'hidden' }}>
      <div style={{ maxWidth: '1200px', margin: 'auto' }}>
        <motion.div 
          style={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            justifyContent: 'center', // Vycentrováno pro případ, že jich je na řádku míň
            gap: '20px', 
            textAlign: 'center' 
          }}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.2
              }
            }
          }}
        >
          {data.map((item) => (
            <FeatureItem 
              key={item.id} 
              imgSrc={`images/${item.id}.png`} 
              title={item.title} 
              text={item.text}
            />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;